export const SHARED_NAV_TREE = {
  label: 'Shared', secondaryItems: [
    {
      label: 'Shared',
      key: 'shared',
      attributes: { href: '/docs/shared/overview' }
    },
    {
      label: 'Feature Affiliation Access',
      key: 'shared-feature-affiliation-access',
      attributes: { href: '/docs/shared/feature-affiliation-access' }
    },
    {
      label: 'Feature Edit Persona Modal',
      key: 'shared-feature-edit-persona-modal',
      attributes: { href: '/docs/shared/feature-edit-persona-modal' }
    },
    {
      label: 'Feature Household Invite',
      key: 'shared-feature-household-invite',
      attributes: { href: '/docs/shared/feature-household-invite' }
    },
    {
      label: 'Feature Household Review',
      key: 'shared-feature-household-review',
      attributes: { href: '/docs/shared/feature-household-review' }
    },
    {
      label: 'Feature Membership List',
      key: 'shared-feature-membership-list',
      attributes: { href: '/docs/shared/feature-membership-list' }
    },
    {
      label: 'Feature Merge Persona Modal',
      key: 'shared-feature-merge-persona-modal',
      attributes: { href: '/docs/shared/feature-merge-persona-modal' }
    },
    {
      label: 'Feature Organization List',
      key: 'shared-feature-organization-list',
      attributes: { href: '/docs/shared/feature-organization-list' }
    },
    {
      label: 'Feature Persona Image Modal',
      key: 'shared-feature-persona-image-modal',
      attributes: { href: '/docs/shared/feature-persona-image-modal' }
    },
    {
      label: 'Feature Profile Side Panel',
      key: 'shared-feature-profile-side-panel',
      attributes: { href: '/docs/shared/feature-profile-side-panel' }
    },
    {
      label: 'Feature Registration List',
      key: 'shared-feature-registration-list',
      attributes: { href: '/docs/shared/feature-registration-list' }
    },
    {
      label: 'Feature Remove Persona Modal',
      key: 'shared-feature-remove-persona-modal',
      attributes: { href: '/docs/shared/feature-remove-persona-modal' }
    },
    {
      label: 'Feature Team List',
      key: 'shared-feature-team-list',
      attributes: { href: '/docs/shared/feature-team-list' }
    },
    {
      label: 'UI Address',
      key: 'shared-ui-address',
      attributes: { href: '/docs/shared/ui-address' }
    },
    {
      label: 'UI Add Child Profile',
      key: 'shared-ui-add-child-profile',
      attributes: { href: '/docs/shared/ui-add-child-profile' }
    },
    {
      label: 'UI Add Guardian',
      key: 'shared-ui-add-guardian',
      attributes: { href: '/docs/shared/ui-add-guardian' }
    },
    {
      label: 'UI Child Contact Info',
      key: 'shared-ui-child-contact-info',
      attributes: { href: '/docs/shared/ui-child-contact-info' }
    },
    {
      label: 'UI Contact Info',
      key: 'shared-ui-contact-info',
      attributes: { href: '/docs/shared/ui-contact-info' }
    },
    {
      label: 'UI Country Select',
      key: 'shared-ui-country-select',
      attributes: { href: '/docs/shared/ui-country-select' }
    },
    {
      label: 'UI Disability Status Select',
      key: 'shared-ui-disability-select',
      attributes: { href: '/docs/shared/ui-disability-select' }
    },
    {
      label: 'UI DOB Select',
      key: 'shared-ui-dob-select',
      attributes: { href: '/docs/shared/ui-dob-select' }
    },
    {
      label: 'UI Edit Persona',
      key: 'shared-ui-edit-persona',
      attributes: { href: '/docs/shared/ui-edit-persona' }
    },
    {
      label: 'UI Email',
      key: 'shared-ui-email',
      attributes: { href: '/docs/shared/ui-email' }
    },
    {
      label: 'UI Gender Select',
      key: 'shared-ui-gender-select',
      attributes: { href: '/docs/shared/ui-gender-select' }
    },
    {
      label: 'UI Graduation Select',
      key: 'shared-ui-graduation-select',
      attributes: { href: '/docs/shared/ui-graduation-select' }
    },
    {
      label: 'UI Guardian Invite Info',
      key: 'shared-ui-guardian-invite-info',
      attributes: { href: '/docs/shared/ui-guardian-invite-info' }
    },
    {
      label: 'UI Highlight Label',
      key: 'shared-ui-highlight-label',
      attributes: { href: '/docs/shared/ui-highlight-label' }
    },
    {
      label: 'UI Military Status Select',
      key: 'shared-ui-military-select',
      attributes: { href: '/docs/shared/ui-military-select' }
    },
    {
      label: 'UI Name',
      key: 'shared-ui-name',
      attributes: { href: '/docs/shared/ui-name' }
    },
    {
      label: 'UI Overview Card',
      key: 'shared-ui-overview-card',
      attributes: { href: '/docs/shared/ui-overview-card' }
    },
    {
      label: 'UI Registration Card',
      key: 'shared-ui-registration-card',
      attributes: { href: '/docs/shared/ui-registration-card' }
    },
    {
      label: 'UI Parent Contact Info',
      key: 'shared-ui-parent-contact-info',
      attributes: { href: '/docs/shared/ui-parent-contact-info' }
    },
    {
      label: 'UI Persona Avatar',
      key: 'shared-ui-persona-avatar',
      attributes: { href: '/docs/shared/ui-persona-avatar' }
    },
    {
      label: 'UI Persona Avatar Group',
      key: 'shared-ui-persona-avatar-group',
      attributes: { href: '/docs/shared/ui-persona-avatar-group' }
    },
    {
      label: 'UI Persona Choice',
      key: 'shared-ui-persona-choice',
      attributes: { href: '/docs/shared/ui-persona-choice' }
    },
    {
      label: 'UI Persona Eligibility',
      key: 'shared-ui-persona-eligibility',
      attributes: { href: '/docs/shared/ui-persona-eligibility' }
    },
    {
      label: 'UI Persona Info',
      key: 'shared-ui-persona-info',
      attributes: { href: '/docs/shared/ui-persona-info' }
    },
    {
      label: 'UI Persona Picker',
      key: 'shared-ui-persona-picker',
      attributes: { href: '/docs/shared/ui-persona-picker' }
    },
    {
      label: 'UI Phone',
      key: 'shared-ui-phone',
      attributes: { href: '/docs/shared/ui-phone' }
    },
    {
      label: 'UI Profile Bar',
      key: 'shared-ui-profile-bar',
      attributes: { href: '/docs/shared/ui-profile-bar' }
    },
    {
      label: 'UI Profile Side Panel',
      key: 'shared-ui-profile-side-panel',
      attributes: { href: '/docs/shared/ui-profile-side-panel' }
    },
    {
      label: 'Util Print Element Service',
      key: 'shared-util-print-element-service',
      attributes: { href: '/docs/shared/util-print-element-service' }
    },
    {
      label: 'UI Race and Ethnicity Multi Select',
      key: 'shared-ui-ethnicity-select',
      attributes: { href: '/docs/shared/ui-ethnicity-select' }
    },
    {
      label: 'UI Setup Bar',
      key: 'shared-ui-setup-bar',
      attributes: { href: '/docs/shared/ui-setup-bar' }
    },
    {
      label: 'UI State Select',
      key: 'shared-ui-state-select',
      attributes: { href: '/docs/shared/ui-state-select' }
    },
    {
      label: 'UI Suffix Select',
      key: 'shared-ui-suffix-select',
      attributes: { href: '/docs/shared/ui-suffix-select' }
    }
  ]
}
